import { ErrorHandler } from '@angular/core';
import { Subject } from "rxjs";
export class HttpError extends Error {
    constructor(message) {
        super(message);
    }
}
export class ErrorCatchingService extends ErrorHandler {
    constructor() {
        super(...arguments);
        this.error$ = new Subject();
    }
    handleError(error) {
        const originalError = this.ensureIsError(this.findOriginalError(error));
        setTimeout(() => this.error$.next(originalError));
        super.handleError(error);
    }
    findOriginalError(error) {
        while (error) {
            if (error.originalError) {
                error = error.originalError;
            }
            else if (error.rejection) {
                error = error.rejection;
            }
            else {
                break;
            }
        }
        return error;
    }
    ensureIsError(thrown) {
        if (thrown instanceof Error) {
            return thrown;
        }
        else if (thrown.name && thrown.message) {
            return thrown;
        }
        else if (thrown.status && thrown.statusText) {
            const e = new HttpError(thrown.toString());
            e.name = "Server Communication Failure";
            e.status = thrown.status;
            e.statusText = thrown.statusText;
            return e;
        }
        else {
            return new Error(thrown.toString());
        }
    }
}
